import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const getToken = () => localStorage.getItem('malife_admin_token');
const setToken = (t) => localStorage.setItem('malife_admin_token', t);
const clearToken = () => localStorage.removeItem('malife_admin_token');

const authHeaders = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

const api = {
  getToken,
  setToken,
  clearToken,
  isAuthed: () => !!getToken(),

  login: (email, password) =>
    axios.post(`${API}/admin/login`, { email, password }).then((r) => {
      setToken(r.data.token);
      return r.data;
    }),

  listMessages: () => axios.get(`${API}/admin/messages`, authHeaders()).then((r) => r.data),
  listWaitlist: () => axios.get(`${API}/admin/waitlist`, authHeaders()).then((r) => r.data),
  getContent: () => axios.get(`${API}/content`).then((r) => r.data),

  createService: (data) => axios.post(`${API}/admin/services`, data, authHeaders()).then((r) => r.data),
  updateService: (id, data) => axios.put(`${API}/admin/services/${id}`, data, authHeaders()).then((r) => r.data),
  deleteService: (id) => axios.delete(`${API}/admin/services/${id}`, authHeaders()).then((r) => r.data),

  createFaq: (data) => axios.post(`${API}/admin/faqs`, data, authHeaders()).then((r) => r.data),
  updateFaq: (id, data) => axios.put(`${API}/admin/faqs/${id}`, data, authHeaders()).then((r) => r.data),
  deleteFaq: (id) => axios.delete(`${API}/admin/faqs/${id}`, authHeaders()).then((r) => r.data),

  createTestimonial: (data) => axios.post(`${API}/admin/testimonials`, data, authHeaders()).then((r) => r.data),
  updateTestimonial: (id, data) => axios.put(`${API}/admin/testimonials/${id}`, data, authHeaders()).then((r) => r.data),
  deleteTestimonial: (id) => axios.delete(`${API}/admin/testimonials/${id}`, authHeaders()).then((r) => r.data),
};

export default api;
